import cn from 'clsx';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';

import { FollowedLoadsPagination } from 'components/FollowedLoadsPagination';
import { FollowedLoadsPerPageSelect } from 'components/FollowedLoadsPerPageSelect';
import { useStore } from 'hooks/useStore';
import { AuctionIcon } from 'layout/Search/FollowedLoads/AuctionIcon';
import { PrettyLoad } from 'layout/Search/PrettyLoad';
import { TabsContent } from 'layout/TabsContent';

import css from './ContentWithAuctions.module.css';

const ContentWithAuctions = () => {
  const {
    app: { i18n },
    view,
    followedLoads: { favorites, loadsWithOffers, loadsWithAuctions },
    etrnPromo,
    ui: { pagination, handleTabChange },
  } = useStore();

  const callbacks = useMemo(
    () => ({
      hideLoads: () => {},
      selectLoads: loadsWithAuctions.selectedLoads.toggleSelection,
      onRemoveLoadFromFavorites: favorites.updateLoads,
      onAddLoadToFavorites: favorites.updateLoads,
      onOfferChange: loadsWithOffers.updateLoads,
      onCounterOfferSend: etrnPromo.showPopupAfterCounterOffer,
      onAuctionChange: loadsWithAuctions.updateLoads,
      onFilterTabOpen: handleTabChange,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  if (loadsWithAuctions.count === 0) {
    return (
      <TabsContent.NoContent
        className={css.noContent}
        desc={''}
        icon={<AuctionIcon />}
        title={i18n.favorites.noContent.auctions.title}
      />
    );
  }

  return (
    <div>
      <div className={css.heading}>
        <h2 className={cn(css.totalItems, 'glz-h glz-is-size-2')}>
          {view.pluralizedCount(loadsWithAuctions.count, 'loads')}
        </h2>

        <FollowedLoadsPagination />
      </div>

      <div className={cn(css.actions, css.actions_top)}>
        <FollowedLoadsPerPageSelect isRow />
      </div>

      <PrettyLoad
        callbacks={callbacks}
        currentPage={pagination.pages.onlyWithAuctions}
        descriptor={{ isFavorites: true }}
        loads={loadsWithAuctions.loads}
        updateLoad={loadsWithAuctions.updateLoad}
      />

      {pagination.totalLoadsWithAuctionsPages > 1 && (
        <div className={cn(css.actions, css.actions_bottom)}>
          <FollowedLoadsPagination />

          <FollowedLoadsPerPageSelect containerClassName={css.sortField} />
        </div>
      )}
    </div>
  );
};

const connected = observer(ContentWithAuctions);

export { connected as ContentWithAuctions };
